<ng-container *ngIf="enabledAnimatedHeader$ | async">
  <div class="headerAnimated__cont headerAnimated__cont-{{dsHeaderConfig?.animatedType}} headerAnimated__cont-{{toKebabCase(dsHeaderConfig?.pageType)}} headerAnimated__cont--{{animatedHeaderState}}">
    <app-ds-header
      [type]="dsHeaderConfig?.animatedType"
      [widgetConfig]="widgets$ | async"
      (clickAction)="widgetClicked.emit($event)">
      </app-ds-header>
  </div>
</ng-container>
